

<div class="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
  <a class="dropdown-item" href="#"><i class="dropdown-icon mdi mdi-account-outline"></i> Profile</a>
  <a class="dropdown-item" href="#"><i class="dropdown-icon mdi mdi-settings"></i> Settings</a>
  <a class="dropdown-item" href="#"><span class="float-right"><span class="badge badge-primary">6</span></span> <i class="dropdown-icon mdi mdi-message-outline"></i> Inbox</a>
  <a class="dropdown-item" href="#"><i class="dropdown-icon mdi mdi-comment-check-outline"></i> Message</a>
  <div class="dropdown-divider"></div>
  <a class="dropdown-item" href="#"><i class="dropdown-icon mdi mdi-compass-outline"></i> Need help?</a>
  <a class="dropdown-item" href="#" (click)="onLogOut()"><i class="dropdown-icon mdi mdi-logout-variant"></i> Sign out</a>
</div>